const __WEBPACK_NAMESPACE_OBJECT__ = require("ethereum-cryptography/secp256k1.js");